module.exports = __webpack_public_path__ + "static/step1-9a971648cb07387cd68ab4d0670f5e6c.png";